module.exports = __webpack_public_path__ + "img/left_bottom_2.9c10317.png";